<template>
  <div
    v-if="show"
    class="empty-state__wrapper"
  >
    <div class="empty-state__container">
      <div class="empty-state__title">
        Não há dados para exibição
      </div>
      <div class="empty-state__description">
        Tente uma combinação diferente de fitros para ter resultados.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
.empty-state {
  &__wrapper {
    position: relative;
    height: 256px;
  }

  &__container {
    width: 100%;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: -50%;
    transform: translate(-50%, -50%);
  }

  &__title {
    text-align: center;
    color: var(--ds-color-text-1);
    font-weight: var(--ds-font-weight-semibold);
    margin-bottom: var(--ds-spacing-stack-nano);
  }

  &__description {
    text-align: center;
    color: var(--ds-color-text-2);
  }
}
</style>
